// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file workspace/workspace_requests.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file workspace/workspace_requests.proto.
 */
export const file_workspace_workspace_requests: GenFile =
  /*@__PURE__*/
  fileDesc(
    'CiJ3b3Jrc3BhY2Uvd29ya3NwYWNlX3JlcXVlc3RzLnByb3RvEhRjb20uZ2VtLmJmZi5jb250cmFjdCIVChNHZXRXb3Jrc3BhY2VSZXF1ZXN0IlgKGEdldFdvcmtzcGFjZVVzZXJzUmVxdWVzdBITCgZjdXJzb3IYASABKAlIAIgBARISCgVsaW1pdBgCIAEoBUgBiAEBQgkKB19jdXJzb3JCCAoGX2xpbWl0ImwKHVNlYXJjaFVzZXJzSW5Xb3Jrc3BhY2VSZXF1ZXN0Eg0KBXF1ZXJ5GAEgASgJEhMKBmN1cnNvchgCIAEoCUgAiAEBEhIKBWxpbWl0GAMgASgFSAGIAQFCCQoHX2N1cnNvckIICgZfbGltaXRCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z'
  );

/**
 * @generated from message com.gem.bff.contract.GetWorkspaceRequest
 */
export type GetWorkspaceRequest = Message<'com.gem.bff.contract.GetWorkspaceRequest'> & {};

/**
 * Describes the message com.gem.bff.contract.GetWorkspaceRequest.
 * Use `create(GetWorkspaceRequestSchema)` to create a new message.
 */
export const GetWorkspaceRequestSchema: GenMessage<GetWorkspaceRequest> =
  /*@__PURE__*/
  messageDesc(file_workspace_workspace_requests, 0);

/**
 * @generated from message com.gem.bff.contract.GetWorkspaceUsersRequest
 */
export type GetWorkspaceUsersRequest = Message<'com.gem.bff.contract.GetWorkspaceUsersRequest'> & {
  /**
   * @generated from field: optional string cursor = 1;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message com.gem.bff.contract.GetWorkspaceUsersRequest.
 * Use `create(GetWorkspaceUsersRequestSchema)` to create a new message.
 */
export const GetWorkspaceUsersRequestSchema: GenMessage<GetWorkspaceUsersRequest> =
  /*@__PURE__*/
  messageDesc(file_workspace_workspace_requests, 1);

/**
 * @generated from message com.gem.bff.contract.SearchUsersInWorkspaceRequest
 */
export type SearchUsersInWorkspaceRequest =
  Message<'com.gem.bff.contract.SearchUsersInWorkspaceRequest'> & {
    /**
     * @generated from field: string query = 1;
     */
    query: string;

    /**
     * @generated from field: optional string cursor = 2;
     */
    cursor?: string;

    /**
     * @generated from field: optional int32 limit = 3;
     */
    limit?: number;
  };

/**
 * Describes the message com.gem.bff.contract.SearchUsersInWorkspaceRequest.
 * Use `create(SearchUsersInWorkspaceRequestSchema)` to create a new message.
 */
export const SearchUsersInWorkspaceRequestSchema: GenMessage<SearchUsersInWorkspaceRequest> =
  /*@__PURE__*/
  messageDesc(file_workspace_workspace_requests, 2);
